export default __webpack_public_path__ + "static/media/choose3.08ff20a9.png";